<template>
  <div>
    <row>
      <col6>
        {{$t('set_label_groups.current_annotations')}}
      </col6>
      <col6>
        <v-btn v-if="show_label_preview" small color="primary" @click="togglePreview">
          <v-icon x-small>
            fas fa-eye
          </v-icon>
        </v-btn>
        <v-btn v-else small color="primary" @click="togglePreview">
          <v-icon x-small>
            fas fa-eye-slash
          </v-icon>
        </v-btn>
      </col6>
    </row>
    <row v-if="!show_label_preview">
      <col12>
        <v-chip
                :dark="annotation.selected"
                :style="{
                'font-weight': annotation.selected ? 'bold': '',
                'background-color': annotation.color_values ? 'rgba('+ annotation.color_values[0] + ',' + annotation.color_values[1] + ',' + annotation.color_values[2] + ')' : '#666' }"
                style="float: left;" 
                v-for="annotation in filtered_annotations" :key="annotation.id"
                @click="toggleSelect(annotation)">
          {{ annotation.label }} - {{ annotation.conf }}
                <i class="fas fa-table-cells-large small ml-2"></i>
        </v-chip>
      </col12>
    </row>
    <row v-else>
      <col12>
        <row v-for="annotation in filtered_annotations" :key="annotation.id">

          <col6 style="padding-top: 0px; padding-bottom: 2px;">
            <v-chip
                :dark="annotation.selected"
                :style="{
                'font-weight': annotation.selected ? 'bold': '',
                'background-color': annotation.color_values ? 'rgba('+ annotation.color_values[0] + ',' + annotation.color_values[1] + ',' + annotation.color_values[2] + ')' : '#666' }"
                style="float: left;" 
                @click="toggleSelect(annotation)">
          {{ annotation.label }} - {{ annotation.conf }}
                <i class="fas fa-table-cells-large small ml-2"></i>
            </v-chip>
          </col6>
          <col6>
            <div v-if="labelid2_crop[annotation.label]">
              <img :src="'data:image/png;base64, ' + labelid2_crop[annotation.label]" style="max-width: 100%; max-height: 100px;"/>
            </div>
          </col6>
        </row>
        
      </col12>
    </row>
    <row>
      <col12>
        <annotate-labels v-if="selected" :type="selected.type" :placeholder="'Change label'"
                         @add_annotation="updateAnnotation"></annotate-labels>
      </col12>
    </row>

    <v-btn rounded style="margin-right: 5px; " small color="primary" id="clear_button_05" @click="clearAnnotations(0.3)">{{$t('set_label_groups.clear_annotations')}}</v-btn>
    <v-btn rounded small color="primary" id="clear_button" @click="clearAnnotations">{{$t('set_label_groups.clear_all')}}</v-btn>

    <row>
      <col12>
        <v-text-field
            id="filter_annotations"
            v-model="filter_annotations"
            density="compact"
            hide-details
            :label="$t('set_label_groups.filter_annotations')"
        ></v-text-field>
      </col12>
    </row>
  </div>
</template>

<script>
  import AnnotateLabels from "@/components/AnnotateLabels";
  import Col12 from "@/components/layout/Col12";
  import Col6 from "@/components/layout/Col6";
  import Row from "@/components/layout/Row";
  // import MyBoxesModal from "@/components/MyBoxesModal";

  export default {
    name: "AnnotationsList",
    data () {
      return {
        'filter_annotations': '',
        'show_boxes_modal': false,
        'boxes_modal_label_name': false,
        'show_label_preview': this.getStoredPreviewState(),
        'labelid2_crop': {},
        'crop_fetch_pending': {},
      }
    },
    components: {Row, Col12, Col6, AnnotateLabels},
    props: {
      'annotations': {
        required: true
      },
      'suggestions': {
        required: false
      }
    },
    watch: {
      annotations(newVal, oldVal) {
        if (
          oldVal
          && (newVal.length !== oldVal.length || this.hasDifferentLabels(newVal, oldVal))
        ) {
          this.labelid2_crop = {};
          this.crop_fetch_pending = {};
        }
        this.fetchLabelCrops();
      },
      show_label_preview(newVal) {
        this.storePreviewState(newVal);
      },
    },
    computed: {
      'selected'() {
        let selected = this.annotations.filter(a => {
          return a.selected
        })
        if (selected.length > 0) {
          return selected[0]
        } else return false;
      },
      filtered_annotations () {
        if(this.filter_annotations === '') {
          return this.annotations
        }
        return this.annotations.filter(annotation=>{return annotation.label.toLowerCase().includes(this.filter_annotations.toLowerCase())})
      },
    },
    methods: {
      fetchLabelCrops() {
        const project_id = sessionStorage.getItem('project_id');
        if (!project_id) {
          return;
        }
        const labels = new Set(
          this.annotations.map((annotation) => annotation.label).filter(Boolean)
        );
        for (const label of labels) {
          if (this.labelid2_crop[label] || this.crop_fetch_pending[label]) {
            continue;
          }
          this.crop_fetch_pending[label] = true;
          this.$api.label.get_crop(label, project_id)
            .then((response) => {
              this.labelid2_crop[label] = response.crop;
            })
            .finally(() => {
              delete this.crop_fetch_pending[label];
            });
        }
      },
      getStoredPreviewState() {
        try {
          const stored = localStorage.getItem('show_label_preview');
          return stored ? JSON.parse(stored) : false;
        } catch (e) {
          return false;
        }
      },
      storePreviewState(state) {
        try {
          localStorage.setItem('show_label_preview', JSON.stringify(state));
        } catch (e) {
          // Silently fail if localStorage is not available
        }
      },
      preview_label_in_modal(label_name) {
        this.show_boxes_modal = true;
        this.boxes_modal_label_name = label_name;
      },
      close_preview_label_in_modal() {
        this.show_boxes_modal = false;
        this.boxes_modal_label_name = null;
      },
      updateAnnotation(annotation) {
        this.$emit('update_label', this.selected.id, annotation.label);
      },
      clearAnnotations(less_than) {
        this.$emit('clear', less_than)
      },
      clearAnnotationsLessThan(value) {
        this.$emit('clear_less_than', value)
      },
      toggleSelect(annotation) {
        if (annotation.selected) {
          this.$emit('unselect', annotation.id);
        } else {
          this.$emit('select', annotation.id);
        }
      },
      togglePreview() {
        this.show_label_preview = !this.show_label_preview;
      },
      hasDifferentLabels(newAnnotations, oldAnnotations) {
        if (!oldAnnotations || oldAnnotations.length === 0) {
          return newAnnotations.length > 0;
        }
        const newLabels = new Set(newAnnotations.map(a => a.label));
        const oldLabels = new Set(oldAnnotations.map(a => a.label));
        
        // Check if there are any new labels that weren't in the old annotations
        for (let label of newLabels) {
          if (!oldLabels.has(label)) {
            return true;
          }
        }
        
        // Check if there are any old labels that aren't in the new annotations
        for (let label of oldLabels) {
          if (!newLabels.has(label)) {
            return true;
          }
        }
        
        return false;
      }
    }
  }
</script>

<style scoped>

</style>